import { defineMobileFormWindow, defineMobileWindow } from "@app/overlay";
import { WsInvActCardSearchForm } from "./components/WsInvActCardSearch/WsInvActCardSearchForm";
import { WsInvActContentForm } from "./components/WsInvActContentForm/WsInvActContentForm";
import { WsInvActIndefiniteResultContent } from "./components/WsInvActIndefiniteResultContent/WsInvActIndefiniteResultContent";

/**
 * Реестр overlay-окон карточки акта инвентаризации УП.
 */
export const wsInvActCardWindows = {
    search: defineMobileFormWindow({
        key: "workshop.invAct.cardSearch",
        title: "Поиск элемента состава АИ",
        closeOnSubmit: false,
        component: WsInvActCardSearchForm,
    }),
    indefiniteResult: defineMobileWindow({
        key: "workshop.invAct.indefiniteResult",
        title: "Выбор элемента состава АИ",
        component: WsInvActIndefiniteResultContent,
    }),
    content: defineMobileFormWindow({
        key: "workshop.invAct.content",
        title: ({ actNum }) => `Элемент АИ №${actNum}`,
        component: WsInvActContentForm,
    }),
};
